import { createAtom } from '~utils/atoms';
var scrollParentAtom = createAtom(null);
export { scrollParentAtom };
